export default __webpack_public_path__ + "static/alfonso-6c676fe361d3fab9b1740aed73cf641c.png";